import React, { useEffect, useRef, useState } from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { useToast } from 'react-native-toast-notifications';
import { Page, showToast } from '../../components';
import { useAppDispatch } from '../../hooks';
import { Button, ButtonContainer, FormContainer, Input, InputRefProps } from '../../components/Form';
import { setLoading } from '../../store/portal/portalActions';
import otpService from '../../services/otpService';
import { OtpCodeModel, ValidateOtpCodeModel /** OtpInputSchema */ } from '../../types';
import { yupErrorsMessage } from '../../utils/yup';
import CountdownTimer from '../../components/CountdownTimer';

export const RegistrationOtp = ({ navigation }: any) => {
  const dispatch = useAppDispatch();

  const route = useRoute();
  const toast = useToast();

  const inputOtpCode = useRef<InputRefProps>(null);
  const [otpCode] = useState<any>();
  const [attemptCount, setAttemptCount] = useState<number>(1);
  const { mobileNo } = route.params as { mobileNo: number };

  const initialDuration = 180; // default 3 minutes
  const [duration, setDuration] = useState(initialDuration);

  useEffect(() => {
    dispatch(setLoading(true));
    let user: OtpCodeModel = {
      mobileNo: mobileNo,
    };
    otpService.getOtp(user).then(res => {
      dispatch(setLoading(false));
    });
  }, []);

  const doSubmitBtn = async () => {
    dispatch(setLoading(true));

    console.log('attemptCount>>>', attemptCount);

    const otpCodeInput = parseInt(inputOtpCode.current?.value || '', 10);
    let otpCodes: ValidateOtpCodeModel = {
      mobileNo: mobileNo.toString(),
      code: otpCodeInput,
      otpAttemptCount: attemptCount,
    };

    // OtpInputSchema.validate(otpCodes, { abortEarly: false, context: { isEdit: true } })
    //     .then(async (obj: any) => {
    otpService
      .validateOtp(otpCodes)
      .then(res => {
        if (res.status === 200 && res.data.resultCode === 0) {
          showToast(toast, { message: 'OTP success', type: 'success' });
          dispatch(setLoading(false));

          navigation.navigate('login');
        } else {
          setAttemptCount(res.data.data.otpAttemptCount);
          dispatch(setLoading(false));
          showToast(toast, { message: res.data.resultMessage, type: 'error' });

          const isDataEmpty = Object.keys(res.data.data).length === 0 && res.data.data.constructor === Object;

          if (isDataEmpty) navigation.navigate('login');
        }
      })
      .catch(err => {
        showToast(toast, { message: yupErrorsMessage(err).join('\n'), type: 'error' });
        dispatch(setLoading(false));
      });
  };

  const handleRestartTimer = () => {
    console.log('handleRestart>>>');
    setDuration(initialDuration); // Reset the duration
    let user: OtpCodeModel = {
      mobileNo: mobileNo,
    };
    otpService.getOtp(user).then(res => {
      dispatch(setLoading(false));
    });
  };

  return (
    <Page title={'OTP Validation'}>
      <FormContainer title="">
        <Input label={'OTP Code'} id="otpCode" value={otpCode} schemaContext={{ isNew: true }} ref={inputOtpCode} />
        <TouchableOpacity style={otpStyle.resendContainer}>
          <CountdownTimer duration={duration} onRestart={handleRestartTimer} />
        </TouchableOpacity>
        <ButtonContainer containerStyle={otpStyle.buttonContainer}>
          <Button onPress={() => doSubmitBtn()}>Verify</Button>
        </ButtonContainer>
      </FormContainer>
    </Page>
  );
};

const otpStyle = StyleSheet.create({
  resendContainer: {
    flex: 1,
    flexDirection: 'row',
    paddingTop: 15,
    paddingBottom: 15,
  },
  timeRemainContainer: {
    flex: 1,
    flexDirection: 'row',
  },
  buttonContainer: {
    alignSelf: 'stretch',
  },
  submitButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000',
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: '#000',
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  submitText: {
    color: '#fff',
  },
  resendText: {
    color: '#000',
    textDecorationLine: 'underline',
    fontWeight: 'bold',
  },
  timerText: {
    color: '#000',
    paddingEnd: 10,
  },
});
